import CourseStaff from "../../course-staff";
import { CreateCourseStaff } from "../../course-staff/pages/create";
import { Detail } from "../../course-staff/pages/detail";


export const courseStaffRoutes = {
  courseStaffPage: {
    isAdmin: false,
    title: "4. Đơn xin nghỉ phép",
    path: "/procedure/course-person-change-form",
    parentId: "procedure",
    component: CourseStaff,
  },
  courseStaffCreatePage: {
    isAdmin: false,
    title: "4. Đơn xin nghỉ phép",
    path: "/procedure/course-person-change-form/create/:id",
    parentId: "procedure",
    component: CreateCourseStaff,
  },
  courseStaffDetailPage:{
    isAdmin: false,
    title: "4. Đơn xin nghỉ phép",
    path: "/procedure/course-person-change-form/details/:id",
    parentId: "procedure",
    component:Detail,
  }
};